module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-chat-e2455dc64e1c399767562878faec11f1.svg";